import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { Instagram, Facebook } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { useSiteContent } from "../context/SiteContentContext";

export default function Footer() {
  const [email, setEmail] = useState("");
  const site = useSiteContent();
  const t = (k, f) => site.text(k, f);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome to the atelier list");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  const newsletterTitle = t("footer_newsletter_title", "Join the\natelier list");

  return (
    <footer className="bg-ink text-ivory" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-20">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <h3 className="font-serif text-5xl md:text-6xl tracking-tight leading-none whitespace-pre-line">
              {newsletterTitle}
            </h3>
            <p className="mt-6 max-w-sm text-sm text-white/60 leading-relaxed">
              {t("footer_newsletter_body", "Private previews, restocks and invitations to our seasonal showings.")}
            </p>
            <form onSubmit={submit} className="mt-8 flex max-w-md items-center border-b border-white/25 pb-3">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="flex-1 bg-transparent text-sm outline-none placeholder:text-white/40"
                data-testid="newsletter-input"
              />
              <button type="submit" className="overline text-gold hover:text-white transition-colors" data-testid="newsletter-submit">
                Subscribe
              </button>
            </form>
          </div>

          <div className="md:col-span-2 md:col-start-8">
            <p className="overline text-white/40 mb-5">{t("footer_shop_heading", "Shop")}</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/shop" className="link-underline">All Pieces</Link></li>
              <li><Link to="/shop?is_new=true" className="link-underline">New Arrivals</Link></li>
              <li><Link to="/collections" className="link-underline">Collections</Link></li>
              <li><Link to="/shop?is_bestseller=true" className="link-underline">Best Sellers</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="overline text-white/40 mb-5">{t("footer_house_heading", "House")}</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/about" className="link-underline">Our Story</Link></li>
              {t("section_journal", "on") !== "off" && (
                <li><Link to="/journal" className="link-underline">Journal</Link></li>
              )}
              <li><Link to="/contact" className="link-underline">Contact</Link></li>
              <li><Link to="/account" className="link-underline">My Account</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-white/10 pt-8">
          <img src="/ambrai-logo.png" alt="Amraiya" className="h-20 w-auto" style={{ filter: "invert(1) brightness(2)" }} />
          <div className="flex items-center gap-5">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-white/60 hover:text-gold transition-colors"><Instagram size={18} /></a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="text-white/60 hover:text-gold transition-colors"><Facebook size={18} /></a>
          </div>
          <p className="mono text-[0.65rem] text-white/40">
            © {new Date().getFullYear()} {t("footer_tagline", "AMRAIYA ATELIER — Made in India")}
          </p>
        </div>
      </div>
    </footer>
  );
}
